import { useQuery } from "@apollo/client";
import { AVATAR_RARITY } from "enefel/career";
import { DICE_LIST } from "enefel/dice";
import { STORE_ITEM_TYPE } from "enefel/store";
import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { GET_CURRENT_SEASON } from "../../query/StandingQueries";
import { Dice } from "../Icon/dice/DiceD6";
import Box from "../Interface/Box";
import ButtonConfirm from "../Interface/ButtonConfirm";
import Col from "../Interface/Col";
import Loading from "../Loading";
import ButtonBuy from "./ButtonBuy";
import { AVATAR_SIZE, rarityGradient } from "./Item";

const Wrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const DicePreview = styled.div<{ $gradient: string }>`
  width: ${AVATAR_SIZE / 2}px;
  height: ${AVATAR_SIZE / 2}px;
  background: ${({ $gradient }: { $gradient: string }) => $gradient} border-box;
  border: 3px solid transparent;
  border-radius: 5px;
`;

type StoreDiceProps = {
  tooth: number;
  onBuy: (itemKey: string) => void;
  loading: boolean;
  purchases: { itemKey: string; type: string }[];
};

const StoreDice: FC<StoreDiceProps> = memo(
  ({ tooth, onBuy, loading, purchases }) => {
    const { t } = useTranslation();
    const { data, loading: loadingSeason } = useQuery(GET_CURRENT_SEASON);

    if (loadingSeason) return <Loading />;

    const currentSeasonId = data?.currentSeason?.id;

    const availableDice = DICE_LIST.filter(
      (d) =>
        d.id !== "default" &&
        d.season === currentSeasonId &&
        !purchases.some((p) => p.itemKey === d.id && p.type === STORE_ITEM_TYPE.DICE)
    );

    if (availableDice.length === 0) return null;

    return (
      <>
        <h2>{t("t:Dice skins", "__Dice skins")}</h2>
        <Wrapper>
          {availableDice.map((dice) => {
            const disabled = loading || tooth < dice.price;
            return (
              <div key={dice.id} style={{ display: "block" }}>
                <Col>
                  <Box
                    header={`${t("t:Season", "__Season")} ${dice.season}`}
                    isSmall={true}
                  >
                    <InnerWrapper>
                      <DicePreview $gradient={rarityGradient[dice.rarity ?? AVATAR_RARITY.COMMUN]}>
                        <Dice dice={dice} value={6} />
                      </DicePreview>
                      <ButtonConfirm
                        disabled={disabled}
                        loading={loading}
                        onAction={() => onBuy(dice.id)}
                        txt={<ButtonBuy price={dice.price} />}
                        txtConfirm={t("t:Sure?", "__Sure?")}
                        warningStyle={false}
                      />
                    </InnerWrapper>
                  </Box>
                </Col>
              </div>
            );
          })}
        </Wrapper>
      </>
    );
  }
);

export default StoreDice;
